export interface ResourceLink {
  readonly description: string
  readonly iconKey: string
  readonly title: string
  readonly url: string
}

export const RESOURCE_LINKS: readonly ResourceLink[] = [
  {
    description: "Step-by-step guide for PII v1 request handling",
    iconKey: "documentation",
    title: "Runbook — PII Access",
    url: "https://atc.bmwgroup.net/confluence/spaces/CDHX/pages/2036992337/PII+API+access+requests+Pseudonymisation+API",
  },
  {
    description: "Architecture, APIs and integration documentation",
    iconKey: "api",
    title: "CDH Platform Docs",
    url: "https://data.bmw.cloud/docs/index.html",
  },
  {
    description: "Reusable operation recipes for common tasks",
    iconKey: "listView",
    title: "Recipes Catalogue",
    url: "https://atc.bmwgroup.net/confluence/spaces/CDHX/pages/1366492089/Recipes",
  },
  {
    description: "Data Management & Governance Framework policies",
    iconKey: "secure",
    title: "DMGF Guidelines",
    url: "https://data.bmw.cloud/docs/for_cdh_developers/auth/operations_manual/operations_manual.html#updating-business-object-governors",
  },
  {
    description: "Track and manage support tickets",
    iconKey: "itSupport",
    title: "Jira — CDH Board",
    url: "https://atc.bmwgroup.net/jira/secure/RapidBoard.jspa?rapidView=41400&projectKey=CDHX#",
  },
] as const

export const localtext = {
  DefaultCount: "0",
  PendingRequests: "Pending Requests",
  Resources: "Resources",
  Title: "CDH Operations Hub",
  TotalOperations: "Total Conducted Operations",
  Welcome: "Welcome back. Here is today's overview.",
} as const
